import apiClient from "@shared/services/apiClient";
import { getBrowserTelemetry } from "@shared/services/telemetry";

export interface FloatingToolbarMetricsSnapshot {
  open_count: number;
  action_count: number;
  error_clicks: number;
  first_action_samples: number;
  total_first_action_ms: number;
  avg_first_action_ms: number | null;
  action_usage: Record<string, number>;
}

export interface FloatingToolbarContextSnapshot {
  toolbar_enabled: boolean;
  edit_mode: boolean;
  mobile_simplified: boolean;
  recording_id?: string;
  study_id?: string;
}

interface FloatingToolbarTelemetryInput {
  metrics: FloatingToolbarMetricsSnapshot;
  context: FloatingToolbarContextSnapshot;
  eventName?: string;
}

export async function trackFloatingToolbarMetrics(
  input: FloatingToolbarTelemetryInput,
): Promise<void> {
  try {
    await apiClient.post("/eeg/toolbar/telemetry", {
      event_name: input.eventName || "floating_toolbar_metrics_snapshot",
      event_ts: new Date().toISOString(),
      source: "serviceapi-eeg-viewer",
      ...getBrowserTelemetry(),
      metrics: input.metrics,
      context: input.context,
    });
  } catch {
    // Best-effort telemetry must never block EEG workflows.
  }
}

